const DEFAULT_DEV_NETWORK_DELAY_MS = 2000;

function parseDelayMs(rawValue: string | undefined) {
  if (!rawValue) return DEFAULT_DEV_NETWORK_DELAY_MS;

  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) return DEFAULT_DEV_NETWORK_DELAY_MS;

  return Math.max(0, Math.floor(parsed));
}

// `import.meta.env` is injected by Vite; under a bare node test runner it is undefined. Fall
// back to "not dev" there rather than throwing at module load.
const ENV: Record<string, string | boolean | undefined> =
  (typeof import.meta !== "undefined" && (import.meta as { env?: Record<string, string | boolean | undefined> }).env) || {};

export const DEV_NETWORK_DELAY_MS = ENV.DEV
  ? parseDelayMs(ENV.VITE_DEV_NETWORK_DELAY_MS as string | undefined)
  : 0;

export function isDevNetworkDelayEnabled() {
  return Boolean(ENV.DEV) && DEV_NETWORK_DELAY_MS > 0;
}

export async function maybeDelayDevNetwork() {
  if (!isDevNetworkDelayEnabled()) return;

  await new Promise((resolve) => {
    globalThis.setTimeout(resolve, DEV_NETWORK_DELAY_MS);
  });
}
